export const LIST_LANGUAGES = ['en', 'ja', 'ko', 'vi'];

export const COMPONENT_OPTIONS = [
  {
    value: 'BANNER',
    label: 'Banner',
  },
  {
    value: 'CAROUSEL',
    label: 'Carousel',
  },
  {
    value: 'SERVICE',
    label: 'Service',
  },
  {
    value: 'FEATURE',
    label: 'Feature',
  },
  {
    value: 'TECHNOLOGY',
    label: 'Technology',
  },
  {
    value: 'FAQ',
    label: 'FAQ',
  },
]

export const COMPONENT_LABELS = {
  BANNER: 'Banner',
  CAROUSEL: 'Carousel',
  SERVICE: 'Service',
  FEATURE: 'Feature',
  TECHNOLOGY: 'Technology',
  FAQ: 'FAQ',
}

export const COMPONENT_VALUES = {
  BANNER: 'BANNER',
  CAROUSEL: 'CAROUSEL',
  SERVICE: 'SERVICE',
  FEATURE: 'FEATURE',
  TECHNOLOGY: 'TECHNOLOGY',
  FAQ: 'FAQ',
}

export const ORDER_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => ({ value: item, label: item }))
